webpackJsonp([234804948918196],{

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Main = __webpack_require__(17);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _CodeBlock = __webpack_require__(15);
	
	var _CodeBlock2 = _interopRequireDefault(_CodeBlock);
	
	var _DevHomework = __webpack_require__(12);
	
	var _DevHomework2 = _interopRequireDefault(_DevHomework);
	
	var _CodepenLink = __webpack_require__(27);
	
	var _CodepenLink2 = _interopRequireDefault(_CodepenLink);
	
	var _DownloadLink = __webpack_require__(16);
	
	var _DownloadLink2 = _interopRequireDefault(_DownloadLink);
	
	var _VideoPlayer = __webpack_require__(57);
	
	var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tutorial = function Tutorial() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_VideoPlayer2.default, { videoId: 'I32g1VYTOAE' }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Your First Grid'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Create a grid'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The first thing we want to do is create a grid container. We can do this by declaring ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'display: grid'
	      ),
	      ' on the container element. In this example we are using a div with the class of ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'container'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Define rows and columns'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'There are several ways to define rows and columns. For our first grid, we will use properties ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'grid-template-columns'
	      ),
	      ' and',
	      " ",
	      _react2.default.createElement(
	        'code',
	        null,
	        'grid-template-rows'
	      ),
	      '. These properties allow us to define the size of the rows and columns for our grid. To create two fixed-height rows of 150px and three fixed-width columns of 150px, simply write:'
	    ),
	    _react2.default.createElement(
	      _CodeBlock2.default,
	      null,
	      '\ngrid-template-columns: 150px 150px 150px;\ngrid-template-rows: 150px 150px;\n      '
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To add a fourth column that is 70px wide, write:'
	    ),
	    _react2.default.createElement(
	      _CodeBlock2.default,
	      null,
	      '\ngrid-template-columns: 150px 150px 150px 70px;\n      '
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '...and so on to add more columns.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Add a gutter'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Adding a gutter to your grid is amazingly easy with CSS Grid Layout. Simply add:'
	    ),
	    _react2.default.createElement(
	      _CodeBlock2.default,
	      null,
	      '\ngrid-gap: 1rem;\n      '
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'That simple line gives you an equal-sized gutter between all rows and columns. To define the gutter size for columns and rows individually, you can use the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'grid-column-gap'
	      ),
	      ' and ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'grid-row-gap'
	      ),
	      " ",
	      'properties instead.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Now let\'s put that all together. Here is our HTML:'
	    ),
	    _react2.default.createElement(
	      _CodeBlock2.default,
	      null,
	      '\n<div class="container">\n  <div class="item item1"></div>\n  <div class="item item2"></div>\n  <div class="item item3"></div>\n  <div class="item item4"></div>\n  <div class="item item5"></div>\n  <div class="item item6"></div>\n</div>\n      '
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'With just a few lines of CSS, we can create a simple grid:'
	    ),
	    _react2.default.createElement(
	      _CodeBlock2.default,
	      null,
	      '\n.container {\n  display: grid;\n  grid-template-columns: 150px 150px 150px;\n  grid-template-rows: 150px 150px;\n  grid-gap: 1rem;\n}\n      '
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Here is the result:'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container-2' },
	      _react2.default.createElement('div', { className: 'item' }),
	      _react2.default.createElement('div', { className: 'item' }),
	      _react2.default.createElement('div', { className: 'item' }),
	      _react2.default.createElement('div', { className: 'item' }),
	      _react2.default.createElement('div', { className: 'item' }),
	      _react2.default.createElement('div', { className: 'item' })
	    ),
	    _react2.default.createElement(_CodepenLink2.default, { link: 'https://codepen.io/mozilladevelopers/pen/veXQmp' })
	  );
	};
	
	var Homework = function Homework() {
	  return _react2.default.createElement(
	    _DevHomework2.default,
	    { title: 'Firefox DevTools + CSS Grid Layout' },
	    _react2.default.createElement(
	      'p',
	      null,
	      'Amazing right? Inspect the grid above with your browser\'s developer tools. Try changing the column width, or the row height. Swap out the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'grid-gap'
	      ),
	      ' property with the',
	      _react2.default.createElement(
	        'code',
	        null,
	        'grid-column-gap'
	      ),
	      ' and ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'grid-row-gap'
	      ),
	      ' properties and play around with different widths and heights.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Having a good set of developer tools when working with CSS Grid Layout is essential. Firefox has some fantastic features that are specifically built to help you create and design grids. Intrigued?',
	      ' ',
	      _react2.default.createElement(
	        _DownloadLink2.default,
	        { content: 'cssgrid-page-2' },
	        'Download Firefox Developer Edition'
	      ),
	      ' to get the browser with the best CSS Grid Layout tools.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Click to the next section to learn about Firefox\'s new CSS Grid Layout panel.'
	    )
	  );
	};
	
	exports.default = function () {
	  return _react2.default.createElement(_Main2.default, { currentPageNum: 2, tutorial: _react2.default.createElement(Tutorial, null), homework: _react2.default.createElement(Homework, null) });
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-css-grid-02-first-grid-js-662a4d70bdacbc5f5c74.js